jQuery(function ($) {
    var scrollPosition = 0;

    $("#copyInput, .copyInput").on("click", function () {
        var $currentElement = $(this);
        $currentElement.text("Copied");
        var targetSelector = $currentElement.data("target");
        var $targetElement = $(targetSelector);
        $targetElement.focus();
        navigator.clipboard.writeText($targetElement.val());
        setTimeout(function () {
            $currentElement.text("Copy");
        }, 2000);
    });

    $(".sidebar-toggle").on("click", function () {
        $(".sidebar").toggleClass("d-none");
        $(".sidebar-overlay").toggleClass("d-none");
    });

    $(".sidebar-overlay").on("click", function () {
        $(".sidebar").addClass("d-none");
        $(".sidebar-overlay").addClass("d-none");
    });

    if (window.matchMedia("(max-width: 575.98px)").matches) {
        $(".sidebar-block").addClass("d-none");
    }

    function hasCookie(cookieName) {
        return document.cookie.split("; ").some(function (cookieString) {
            return cookieString.indexOf(cookieName + "=") === 0;
        });
    }

    var cookieName = "termsUpdateDismissed";

    if (hasCookie(cookieName)) {
        $(".alert.eula").remove();
        return;
    }

    $(document).on("close.bs.alert closed.bs.alert", ".alert.eula", function () {
        document.cookie = cookieName + "=1; path=/; max-age=" + 60 * 60 * 24 * 30;
    });

    $("table.ts-sort").DataTable({
        paging: false,
        pageLength: 100000,
        lengthChange: false,
        info: false,
        searching: false,
        ordering: true
    });

    $(".sortable").sortable({
        start: function (eventObject, userInterfaceObject) {
            scrollPosition = $(window).scrollTop();
        },
        sort: function (eventObject, userInterfaceObject) {
            $(window).scrollTop(scrollPosition);
        }
    });
});
